import { useEffect } from "react";
import { useModalContext } from "../contexts/ModalContext";

export const useBackButtonHandler = (isModalOpen: boolean, onBackPressed: () => void, modalId: string = "default-modal") => {
  const { registerModal, unregisterModal } = useModalContext();

  useEffect(() => {
    if (!isModalOpen) {
      unregisterModal(modalId);
      return;
    }

    registerModal(modalId);

    // Push state to prevent actual back navigation
    window.history.pushState({ modal: modalId }, "");

    const handlePopState = () => {
      onBackPressed();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      unregisterModal(modalId);
    };
  }, [isModalOpen, onBackPressed, modalId, registerModal, unregisterModal]);
};
